//api.js
import http from './../http.js'

export const userRegisterV2 = data => {
    return http({
        url: '/user/RegisterV2',
        method: 'post',
		showLoading:false,
        data
    })
};

 
export const getPersonInfo = data => {
    return http({
        url: '/person_pay/getpersoninfo',
        method: 'post',
		showLoading:false,
        data
    })
};
// 上传用户头像
export const userUploadAvatar = data => {
    return http({
        url: '/user/UploadAvatar',
        method: 'post',
		showLoading:false,
        data
    })
};

// 忘记密码

export const userUpdatePwd = data => {
    return http({
        url: '/user/UpdatePwd',
        method: 'post',
		showLoading:false,
        data
    })
};


export const getTrainSTA= data => {
    return http({
        url: '/index/GetTrainSTA?si_guid='+data,
        method: 'get',
		showLoading:false
    })
};


export const getTrainEquipmentStatusSTA= data => {
    return http({
        url: '/index/GetTrainEquipmentStatusSTA?si_guid='+data,
        method: 'get',
		showLoading:false
    })
};


export const getTrainUsageSTA= data => {
    return http({
        url: '/index/GetTrainUsageSTA?si_guid='+data.si_guid+"&days="+data.time,
        method: 'get',
		showLoading:false
    })
};


export const GetTrainUsageSTA = data => {
    return http({
        url: '/index/GetTrainUsageSTA?si_guid='+data.si_guid+"&days="+data.time,
        method: 'get',
		showLoading:false
    })
};


export const getTrainAppointmentCountSTA = data => {
    return http({
        url: '/index/GetTrainAppointmentCountSTA?si_guid='+data.si_guid+"&days="+data.time,
        method: 'get',
		showLoading:false
    })
};


export const getTrainAnnualSTA = data => {
    return http({
        url: '/index/GetTrainAnnualSTA?si_guid='+data.si_guid+"&year=" +data.year,
        method: 'get',
		showLoading:false
    })
};




